import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("fm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const auth = {
  token: () => localStorage.getItem("fm_token"),
  user: () => {
    const u = localStorage.getItem("fm_user");
    return u ? JSON.parse(u) : null;
  },
  setSession: (token, user) => {
    localStorage.setItem("fm_token", token);
    localStorage.setItem("fm_user", JSON.stringify(user));
  },
  clear: () => {
    localStorage.removeItem("fm_token");
    localStorage.removeItem("fm_user");
  },
};
